import script from "./realtime-monitoring.vue?vue&type=script&lang=ts&setup=true"
export * from "./realtime-monitoring.vue?vue&type=script&lang=ts&setup=true"

import "./realtime-monitoring.vue?vue&type=style&index=0&id=501daeea&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-501daeea"]])

export default __exports__